<template>
  <div :style="styles.base">
    <div :style="styles.content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LibraryGrid',
  props: {
    baseStyle: Object
  },
  data() {
    return {
      styles: {
        base: {
          display: 'flex',
          flexFlow: 'column nowrap',
          width: '100%',
          background: '#f5f5f5',
          minHeight: '100vh',
          padding: '0',
          position: 'relative',
          paddingTop: '60px',
          ...this.baseStyle
        },
        navList: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          flexFlow: 'row nowrap',
          listStyle: 'none',
          padding: '0 0 5px 0',
          margin: 0,
          borderBottom: '1px solid #ddd'
        },
        content: {
          display: 'flex',
          flexFlow: 'row wrap',
          width: '100%',
          padding: '10px'
        },
        navListItem: {
          margin: '5'
        }
      }
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/general/LibraryGrid.vue